import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import arTranslations from './localization/messages/ar.json' with { type: 'json' };
import deTranslations from './localization/messages/de.json' with { type: 'json' };
import enTranslations from './localization/messages/en.json' with { type: 'json' };
import esTranslations from './localization/messages/es.json' with { type: 'json' };
import frTranslations from './localization/messages/fr.json' with { type: 'json' };
import hiTranslations from './localization/messages/hi.json' with { type: 'json' };
import itTranslations from './localization/messages/it.json' with { type: 'json' };
import nlTranslations from './localization/messages/nl.json' with { type: 'json' };
import ptTranslations from './localization/messages/pt.json' with { type: 'json' };
import zhTranslations from './localization/messages/zh.json' with { type: 'json' };

export const SUPPORTED_LANGUAGES = [
  { value: 'de', label: 'Deutsch' },
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
  { value: 'fr', label: 'Français' },
  { value: 'pt', label: 'Português' },
  { value: 'it', label: 'Italiano' },
  { value: 'nl', label: 'Nederlands' },
  { value: 'zh', label: '简体中文' },
  { value: 'hi', label: 'हिन्दी' },
  { value: 'ar', label: 'العربية' },
];

export const languageMap: Record<string, string> = SUPPORTED_LANGUAGES.reduce<Record<string, string>>((acc, lang) => {
  acc[lang.value] = lang.label;
  return acc;
}, {});

const browserLang = typeof navigator !== 'undefined' ? navigator.language.split('-')[0] : 'en';
const initialLng = SUPPORTED_LANGUAGES.some(l => l.value === browserLang) ? browserLang : 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: deTranslations },
      en: { translation: enTranslations },
      es: { translation: esTranslations },
      fr: { translation: frTranslations },
      pt: { translation: ptTranslations },
      it: { translation: itTranslations },
      nl: { translation: nlTranslations },
      zh: { translation: zhTranslations },
      hi: { translation: hiTranslations },
      ar: { translation: arTranslations },
    },
    lng: initialLng,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  })
  .catch(err => {
    console.error(`i18n initialization error: ${err}`);
  });

export default i18n;
